import { translate } from '@/domains/core/localization/translate';
export const colorTranslations = translate({
  "brown": "Brown",
  "red": "Red",
  "purple": "Purple",
  "pink": "Pink",
  "yellow": "Yellow",
  "green": "Green",
  "orange": "Orange",
  "blue": "Blue",
  "beige": "Beige",
  "grey": "Grey",
  "black": "Black",
  "white": "White",
  "multicolor": "Multicolor",
  "transparent": "Transparent",
  "silver": "Silver",
  "golden": "Golden",
  "copper": "Copper",
  "other": "Other"
});